import { CheckIcon, XIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Typography } from '@/components/ui/typography'
import { useNewsletterForm } from './useNewsletterForm'
import type { NewsletterPopupVariantProps } from './NewsletterPopup'
import newsletterImg from '@/assets/home/newsletter.webp'

export function NewsletterPopupMobile({ onClose, onSubscribed }: NewsletterPopupVariantProps) {
  const { email, setEmail, status, submit } = useNewsletterForm(onSubscribed)
  const isSuccess = status === 'success'

  return (
    <div className="relative w-[340px] max-w-full overflow-hidden rounded-2xl bg-white text-center shadow-2xl">
      <button
        type="button"
        onClick={onClose}
        aria-label="Zavřít"
        className="absolute top-3 right-3 z-10 rounded-full bg-white/80 p-1.5 text-slate-700 backdrop-blur-sm transition-colors hover:bg-white"
      >
        <XIcon className="h-5 w-5" />
      </button>

      <div className="relative">
        <img
          src={newsletterImg}
          alt="Pár zachumlaný v dece na terase chalupy nad podzimními horami"
          className="aspect-[16/10] w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-4 text-left text-white">
          <span className="bg-red mb-2 inline-block rounded-full px-2.5 py-0.5 text-[11px] font-semibold">
            Každou středu přímo do e-mailu
          </span>
          <p className="text-xl leading-tight font-bold">Nejlepší last-minute víkendovky</p>
        </div>
      </div>

      <div className="p-6">
        {isSuccess ? (
          <>
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <CheckIcon className="h-6 w-6 text-green-700" />
            </div>
            <Typography variant="h4" className="mb-2">
              Jsi v klubu!
            </Typography>
            <p className="text-slate-900/60">Od teď ti každou středu pošleme nejlepší tipy na víkend.</p>
          </>
        ) : (
          <>
            <span className="text-red mb-2 block text-xs font-semibold tracking-[0.14em] uppercase">
              Tipy na víkend zdarma
            </span>
            <Typography variant="h4" className="mb-2">
              Plány na víkend vyřešené
            </Typography>
            <p className="mb-5 text-slate-900/60">
              Chaty, wellness pobyty i tipy na výlety, kam o víkendu vyrazit — ručně vybíráme to nejlepší.
            </p>
            <form onSubmit={submit} className="space-y-3">
              <Input
                type="email"
                name="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="Zde zadejte Váš e-mail"
                className="h-11 text-center"
              />
              <Button type="submit" className="h-11 w-full text-base" disabled={status === 'submitting'}>
                {status === 'submitting' ? 'Odesílám…' : 'Chci tipy na víkend'}
              </Button>
              {status === 'invalid-email' && <p className="text-red text-sm">Zkontrolujte prosím e-mailovou adresu.</p>}
              {status === 'error' && <p className="text-red text-sm">Něco se nepovedlo, zkuste to prosím znovu.</p>}
            </form>
            <div className="mt-4 flex items-center justify-center gap-1.5 text-sm text-slate-900/50">
              <CheckIcon className="h-4 w-4 shrink-0" />
              <span>Zdarma · kdykoliv se odhlásíš</span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
